module.exports = __webpack_public_path__ + "img/Genuss-Cafe-Speisekarte.99c9bf6c.png";